import React from 'react';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import IconTrash from '@dealroadshow/uikit/core/components/Icon/IconTrash';
import { usePositionsContext } from '@/finsight/application/PortfolioMonitor/PositionsContext';

import styles from './styles.scss';

const BulkDeletePositions = () => {
  const {
    selection,
    confirmDeletePositionsModal: {
      showCanceledModal,
    },
  } = usePositionsContext();

  if (selection.collection.length > 0) {
    return (
      <Button
        dataTest="positionsBulkDeleteButton"
        variant={ ButtonVariantType.link }
        onClick={ showCanceledModal }
        className={ styles.button }
      >
        <IconTrash />
      </Button>
    );
  }

  return null;
};

export default BulkDeletePositions;
